/*
BOLD-COLLECTION-FILTERING.JS

For providing product results based on selected filters.

REQUIRES:
  [TEMPLATE] collection.json.filter               Custom endpoint that generates the highest-level information about the collection we want to filter
  [TEMPLATE] collection.json.filter.products      Custom endpoint that generates a custom list of products
  [ASSET]    bold-collection-filter.scss          CSS styling for the collection-filter widget.  (NOTE: Alternatively, these styles can be added to an existing stylesheet)
  [ASSET]    bold-events.js                       For the BOLD.eventEmitter object               (NOTE: Only required if none of our apps that pull in the eventEmitter are in play)

INSTALLATION:
  1)  Create the following files in the theme:
        /templates/collection.json.filter
        /templates/collection.json.filter.products
        /assets/bold-collection-filtering.js.liquid
        /assets/bold-collection-filter.scss                             (NOTE: Alternatively, these styles can be added to an existing stylesheet)
        /assets/bold-events.js                                          (NOTE: Only required if none of our apps that pull in the eventEmitter are in play)

  2) Add the following to the theme.liquid file:
      <script src="//silkflowersfactory.com/cdn/shop/t/155/assets/bold-events.js?v=55008557037175054641778834365" type="text/javascript"></script>                   (NOTE: Only required if none of our apps that pull in the eventEmitter are in play)
      <script src="//silkflowersfactory.com/cdn/shop/t/155/assets/bold-collection-filtering.js?v=2915879063311924461778836008" type="text/javascript"></script>
      <link href="//silkflowersfactory.com/cdn/shop/t/155/assets/bold-collection-filter.scss?v=9798926577530505551778834365" rel="stylesheet" type="text/css" media="all" />  (NOTE: Only if using a dedicated stylesheet for the collection_filter widget)

  3) Add the following to the /config/settings_schema.json file:
  {
    "name": "BOLD: Collection Filters",
    "settings": [
      {
        "type": "header",
        "content": "Filter Settings"
      },
      {
        "type": "number",
        "id": "bold-collection-filter-products-per-page",
        "label": "Number of products to display per page",
        "default": 40
      },
      {
        "type": "link_list",
        "id": "bold-collection-filters-source-linklist",
        "label": "Menu item (Link-list) containing the filter category names"
      },
      {
        "type": "text",
        "id": "bold-collection-filter-product-area",
        "label": "CSS Selector for the area to print product info in"
      },
      {
        "type": "textarea",
        "id": "bold-collection-filter-product-template",
        "label": "Template for the product grid"
      },
      {
        "type": "text",
        "id": "bold-collection-filter-display-area",
        "label": "CSS Selector for the area to print the filter widget to"
      },
      {
        "type": "textarea",
        "id": "bold-collection-filter-template",
        "label": "Template for the filter widget display"
      },
      {
        "type": "header",
        "content": "Pagination Display"
      },
      {
        "type": "text",
        "id": "bold-collection-filter-pagination-area",
        "label": "CSS Selector for the area to print the pagination widget to",
        "default": ".bold-collection-pagination"
      },
      {
        "type": "text",
        "id": "bold-collection-filter-first",
        "label": "First Page",
        "default": "<<"
      },
      {
        "type": "text",
        "id": "bold-collection-filter-prev",
        "label": "Previous Page",
        "default": "<"
      },
      {
        "type": "text",
        "id": "bold-collection-filter-number",
        "label": "Page Number",
        "default": "[page_number]"
      },
      {
        "type": "text",
        "id": "bold-collection-filter-break",
        "label": "Spacer",
        "default": "..."
      },
      {
        "type": "text",
        "id": "bold-collection-filter-next",
        "label": "Next Page",
        "default": ">"
      },
      {
        "type": "text",
        "id": "bold-collection-filter-last",
        "label": "Last Page",
        "default": ">>"
      },
      {
        "type": "number",
        "id": "bold-collection-filter-pagination-first",
        "label": "Min. pages to show at beginning of pagination bar",
        "default": 3
      },
      {
        "type": "number",
        "id": "bold-collection-filter-pagination-surrounding",
        "label": "Min. pages to show on each side surrounding the current page",
        "default": 2
      },
      {
        "type": "number",
        "id": "bold-collection-filter-pagination-last",
        "label": "Min. pages to show at end of pagination bar",
        "default": 3
      },
      {
        "type": "header",
        "content": "Advanced Settings"
      },
      {
        "type": "number",
        "id": "bold-collection-filter-preload-page-count",
        "label": "Number of pages to fetch immediately on page load",
        "default": 3
      },
      {
        "type": "number",
        "id": "bold-collection-filter-ajaxproducts-per-page",
        "label": "Products to fetch per request",
        "default": 50,
        "info": "Only adjust this number if you need to fine-tune how fast the products are loaded. A higher number makes fewer requests, lower numbers improves the speed that Shopify can generate a response.  The 'Sweet Spot' should be somewhere around 50"
      }
    ]
  }

  4) Go to the 'Customize Theme' page and find the BOLD: Collection Filters heading (on the General Settings tab for themes with sections)
      * Specify the CSS selector used to find and populate the product display grid. (Default if nothing specified: '.bold-product-grid')
      * Specify the CSS selector to use to find the container where the collection filter widget will be printed (Default if nothing specified: '.bold-collection-filters')
      * Specify the CSS selector to use to find the container where the pagination widget will be printed (Default if nothing specified: '.bold-collection-pagination')
      * Add an HTML template for the product display grid. (Copy-pasting from the theme or rendered document and substituting product fields).  Alternatively, you can update the product_grid_template (Liquid capture) below.
          The following substitutions are currently supported:
          [id]                                           product ID
          [handle]                                       product handle
          [title]                                        product title
          [url]                                          product URL
          [price]                                        product price (raw)
          [price_formatted]                              product price (formatted)
          [image]                                        product featured image (url)
          [first_variant_id]       ID of first available variant

  Filters will be automatically generated using all of the options/values attached to the variants in the products of the collection.
  If you need to add additional search values to the products, complete the optional installation below.

OPTIONAL:
   1) In Shopify's admin, go to Online Store > Navigation.  Create a new menu with the handle collections-filters
   2) Add a menu entry for every category you want to add to the collection filter categories. (Examples: color, material, etc.)
       NOTE: It doesn't matter where these link to, as we are not going to use the link as part of this plugin.
       TODO: It might make more sense to move this to theme settings with the rest of the template & setting info...?
   3) Tag products with tags beginning with the custom category name followed by a dash and the desired value to add that value to the product's filter information. (Examples: color-red, material-bronze)

THEME INTEGRATION TIPS:
  This plugin has been written with liberal use of events, with the intent of making theme intgrations as easy as possible.
  To add a behaviour that hooks in to some aspect of this plugin, add an event listener anywhere in the theme's code.  Declaring an event listener takes the following format:

              //First check to make sure the eventEmitter loaded, create a listener if it exists
              if(window.BOLD && BOLD.common && BOLD.common.eventEmitter){
                BOLD.common.eventEmitter.on(event_name, function(a){
                  //Your event code here
                })
               }

  The following events are used in this plugin.  For further debugging information, set BOLD.collection_filter.debugMode = true to force all events to be logged to the console.
    BOLD_COLLECTION_FILTERS_filters_loaded
    BOLD_COLLECTION_FILTERS_products_loaded
    BOLD_COLLECTION_FILTERS_empty_result
    BOLD_COLLECTION_FILTERS_filters_updated
    BOLD_COLLECTION_FILTERS_filter_added
    BOLD_COLLECTION_FILTERS_selections_updated
    BOLD_COLLECTION_FILTERS_filters_applied
    BOLD_COLLECTION_FILTERS_all_collection_filters_applied
    BOLD_COLLECTION_FILTERS_filter_count_updated
    BOLD_COLLECTION_FILTERS_no_print_area
    BOLD_COLLECTION_FILTERS_display_cleared
    BOLD_COLLECTION_FILTERS_no_products
    BOLD_COLLECTION_FILTERS_product_printed
    BOLD_COLLECTION_FILTERS_filter_element_not_found
    BOLD_COLLECTION_FILTERS_filters_drawn
    BOLD_COLLECTION_FILTERS_no_filter_data
    BOLD_COLLECTION_FILTERS_input_changed
    BOLD_COLLECTION_FILTERS_page_changed



TODO: Update URL with search parameters/page number
TODO: Prep for fancy search stuff, date to add TBD
TODO: Toggle for infinite-scroll
TODO: Sort fields!
DONE: Filters auto-generate from product/variant options/values.
      BONUS: On filter applied, grab/check product JSON to see if variants matching the filter selection are sold out

*/

/* ***************************************************************************************************
		Template assignments:*************************************************************************************************** */

/* ***************************************************************************************************
		Main Object Setup
 *************************************************************************************************** */
var BOLD = BOLD || {};
BOLD.collection_filter = {
  debugMode: true,
  hasChangeLastLinkEvent: '',
  withURLonFirstLoad: false,
  collections:{},
  paramAppliedFilters: {},
  templates:{
    product_grid:"\u003cdiv class=\"grid-product-item relative w-full xl:w-[230px] group[on_sale_class][sold_out_class]\"\u003e  \u003cdiv class=\"inline-flex w-full flex-col items-start justify-start gap-[4px] bg-white xl:gap-[5px]\"\u003e    \u003cdiv class=\"relative flex flex-col items-start justify-start self-stretch pb-[5px]\"\u003e      \u003ca href=\"[url]\" class=\"grid-link w-full\"\u003e        \u003cimg class=\"feature-image relative h-full max-h-full w-full max-w-full hover:cursor-pointer hover:opacity-[0.8] xl:h-[230px] xl:max-h-[230px] xl:w-[230px] xl:max-w-[230px]\" src=\"[image]\" alt=\"[image_alt]\" data-original=\"[image]\" data-hover=\"[image_second]\"\u003e        [sold_out_badge]      \u003c\/a\u003e      [sale_badge]    \u003c\/div\u003e    \u003cdiv class=\"flex flex-col items-start justify-start self-stretch\"\u003e      \u003cp class=\"min-h-[30px] justify-center self-stretch overflow-hidden text-ellipsis text-xs font-normal leading-[125%] text-black [-webkit-box-orient:vertical] [-webkit-line-clamp:2] [display:-webkit-box]\"\u003e[title]\u003c\/p\u003e    \u003c\/div\u003e    \u003cdiv class=\"inline-flex h-7 items-center justify-start gap-1 self-stretch py-1\"\u003e      \u003cp class=\"justify-center text-base font-bold leading-normal text-black\"\u003e[price_formatted]\u003c\/p\u003e      [compare_price_html]    \u003c\/div\u003e  \u003c\/div\u003e  \u003cdiv class=\"absolute left-0 top-[40%] hidden w-full items-center justify-center gap-2 overflow-hidden p-2 opacity-0 transition-opacity duration-300 group-hover:opacity-100 lg:top-[50%] lg:inline-flex xl:top-[174px]\"\u003e    \u003cbutton type=\"button\" id=\"product-[id]\" class=\"btn btn-outline btn-sm h-[34px] uppercase btn-qv\" data-handle=\"[handle]\" data-prodid=\"[id]\"\u003eQuick View\u003c\/button\u003e  \u003c\/div\u003e  \u003cdiv id=\"quickview-[id]\" class=\"mfp-hide white-popup\"\u003e\u003c\/div\u003e\u003c\/div\u003e",
    product_list:"\u003cdiv class=\"list-view__product small--text-center\"\u003e  \u003cdiv class=\"grid\"\u003e      \u003cdiv class=\"grid__item large--one-fifth large--display-table-cell medium--one-third\"\u003e          \u003ca href=\"\/collections\/best-sellers\/products\/[handle]\" class=\"grid-link__image\"\u003e            \u003cspan class=\"grid-link__image-centered\"\u003e              \u003cimg src=\"[image]\" alt=\"[title]\"\u003e            \u003c\/span\u003e          \u003c\/a\u003e      \u003c\/div\u003e      \u003cdiv class=\"grid__item large--three-fifths large--display-table-cell medium--two-thirds\"\u003e            \u003ca href=\"\/collections\/best-sellers\/products\/[handle]\"\u003e[title]\u003c\/a\u003e      \u003c\/div\u003e      \u003cdiv class=\"grid__item large--one-fifth large--display-table-cell medium--two-thirds\"\u003e            \u003cstrong\u003e[price_formatted]\u003c\/strong\u003e      \u003c\/div\u003e  \u003c\/div\u003e\u003c\/div\u003e",
    filter_header:"\u003cdiv class=\"bold-filter bold-filter-active\" data-category=\"[category]\" data-collection=\"[collection]\"\u003e    \u003cspan class=\"view-all view-[category]\" data-collection=\"[collection]\" data-category=\"[category]\" style=\"display: inline;\"\u003e\u003ca href=\"#\" class=\"view-all\" data-filter=\"filter-[category]\"\u003eclear\u003c\/a\u003e\u003c\/span\u003e\u003cp class=\"bold-filter-header\" data-collection=\"[collection]\" data-category=\"[category]\"\u003e    [category]    \u003cspan class=\"icon icon-circle-plus\" style=\"font-family: 'launch-icons', sans-serif;\"\u003e+\u003c\/span\u003e    \u003cspan class=\"icon icon-circle-minus heading-active\" style=\"font-family: 'launch-icons', sans-serif; display: none\"\u003e–\u003c\/span\u003e\u003c\/p\u003e\u003cul class=\"bold-filter-wrapper\" data-category=\"[category]\" data-collection=\"[collection]\"\u003e",
    filter_header_no_search:"\u003cdiv class=\"bold-filter bold-filter-active\" data-category=\"[category]\" data-collection=\"[collection]\"\u003e\u003cp class=\"bold-filter-header\" data-collection=\"[collection]\" data-category=\"[category]\"\u003e    [category]    \u003cspan class=\"icon icon-circle-plus\" style=\"font-family: 'launch-icons', sans-serif;\"\u003e+\u003c\/span\u003e    \u003cspan class=\"icon icon-circle-minus heading-active\" style=\"font-family: 'launch-icons', sans-serif; display: none\"\u003e–\u003c\/span\u003e\u003c\/p\u003e\u003cul class=\"bold-filter-wrapper\" data-category=\"[category]\" data-collection=\"[collection]\"\u003e",
    filter_header_toggle:"\u003cdiv class=\"bold-filter bold-filter-active !border-0 filter-header-toggle\" data-category=\"[category]\" data-collection=\"[collection]\"\u003e    \u003cp class=\"my-0 py-[10px] px-[15px] text-black text-sm font-medium leading-none text-left uppercase bg-gray-50 opacity-100 border-b border-white\/20 cursor-pointer justify-between flex bold-filter-header h-[37px]\" data-collection=\"[collection]\" data-category=\"[category]\"\u003e    [category]    \u003cspan class=\"icomoon icomoon-arrow pr-[2px] rotate-90 flex self-center text-xs\"\u003e\u003c\/span\u003e\u003c\/p\u003e\u003cul class=\"bold-filter-wrapper !border-0 bg-white\" data-category=\"[category]\" data-collection=\"[collection]\"\u003e",
    filter_template: "\u003cli class=\"bold-filter-selection\" data-collection=\"[collection]\" data-category=\"[category]\" data-value=\"[value]\"\u003e\u003clabel\u003e[checkbox] \u003cspan class=\"special-name\" data-special-name=\"[value]\"\u003e[display_val]\u003c\/span\u003e [count]\u003c\/label\u003e\u003c\/li\u003e",
    filter_template_new: "\u003cli class=\"bold-filter-selection w-full self-stretch px-[15px] py-[8px] bg-white inline-flex justify-between items-center h-[30px]\" data-collection=\"[collection]\" data-category=\"[category]\" data-value=\"[value]\"\u003e\u003clabel class=\"filter-checkbox inline-flex justify-start items-center gap-1 w-full\"\u003e[checkbox] \u003cspan class=\"special-name justify-start text-black text-xs font-normal\" data-special-name=\"[value]\"\u003e[display_val]\u003c\/span\u003e \u003c\/label\u003e[count]\u003c\/li\u003e",
    filter_footer:"\u003c\/ul\u003e\u003c\/div\u003e",
    filter_search: "\u003cdiv class=\"bold-filter lg:border-[1.50px] lg:border-gray border-0\" data-category=\"product_name\" data-collection=\"[collection]\"\u003e\u003cinput class=\"bold-filter-input bold-filter-search\" data-collection=\"[collection]\" data-category=\"product_name\" type=\"text\" aria-label=\"Search within filters\" placeholder=\"Search within [collection]\"\u003e",
    filter_checkbox: "\u003cinput class=\"bold-filter-input bold-filter-checkbox checkbox-[category]\" data-collection=\"[collection]\" data-category=\"[category]\" data-inputfilter=\"[category]-[value]\" type=\"checkbox\" value=\"[value]\"\u003e",
    filter_checkbox_custom: "\u003cinput type=\"checkbox\" class=\"checkbox-hidden bold-filter-input bold-filter-checkbox checkbox-[category]\" data-collection=\"[collection]\" data-category=\"[category]\" data-inputfilter=\"[category]-[value]\" type=\"checkbox\" value=\"[value]\"\u003e\u003cspan class=\"custom-checkbox\"\u003e\u003c\/span\u003e",
    filter_count: "\u003cspan class=\"bold-filter-count justify-start text-black text-xs font-normal\" data-collection=\"[collection]\" data-category=\"[category]\" data-value=\"[value]\"\u003e\u003c\/span\u003e",
    pagination_header: "\u003cdiv class=\"bold-filter-pagination inline-flex justify-center items-center w-full\" data-collection=\"[collection]\"\u003e[first_page_link][prev_page_link]",
    pagination_first: "\u0026lt;\u0026lt;",
    pagination_prev: "\u0026lt;",
    pagination_element: "[page_number]",
    pagination_element_prefix: '<div class="h-[36px] w-[36px] min-w-[36px] rounded-full"><button type="button" class="bold-collection-filter-pagination-selector text-center !flex justify-center items-center text-brand text-lg font-bold leading-relaxed h-[36px] !w-[36px]" aria-label="Go to page [page_number]" data-collection="[collection]" data-page="[page_number]">',
    pagination_element_suffix: '</button></div>',
    pagination_current_page_prefix: '<div class="bold-collection-filter-current-page !w-[36px] h-[36px] min-w-[36px]" aria-current="page" data-collection="[collection]" data-page="[page_number]"><span class="text-center text-lg font-bold leading-relaxed h-[36px] w-[36px] flex justify-center items-center">',
    pagination_current_page_suffix: '</span></div>',
    pagination_break: "...",
    pagination_next: "\u003e",
    pagination_last: "\u003e\u003e",
    pagination_footer: "[next_page_link][last_page_link]\u003c\/div\u003e"

  },
  selectors:{
    product_display_area:".bold-product-display",
    filter_display_area:".bold-collection-filters",
    filter_header: '.bold-filter',
    filter_header_no_search: '.bold-filter',
    filter_header_toggle: '.bold-filter',
    filter_input: '.bold-filter-input',
    pagination_display_area: ".bold-collection-pagination",

  },
  pagination:{
    products_per_page: 40,
    ajax_products_per_page:50,
    preload_page_count: 3,
    min_pages_at_beginning: 3,
    pages_surrounding_current: 2,
    min_pages_at_end: 3
  },
  forURLParameter:{
    parameterValidation: false,
    parameterCollection: '',
    parameterPagination: 1,
    parameterShowBy: 40,
    parameterViewBy: 'grid',
    parameterSortBy: 'featured',
    parameterFilterBy: {}
  },
  getFilterInfo:function(collection_handle, success_callback, error_callback){

    if(typeof collection_handle != 'string'){
      return null;
    }

    BOLD.helpers.get('/collections/' + collection_handle + '?view=json.filter', function(data){
      if(data && data.all_filters){
        BOLD.collection_filter.collections[collection_handle] = (BOLD.collection_filter.collections[collection_handle] || {});
        BOLD.collection_filter.collections[collection_handle].all_filters = data.all_filters;
        BOLD.collection_filter.collections[collection_handle].product_count = data.product_count;
        var page_count = Math.ceil(data.product_count / (BOLD.collection_filter.pagination.products_per_page || 40));
        var ajax_page_count = Math.ceil(data.product_count / (BOLD.collection_filter.pagination.ajax_products_per_page || 50));
        BOLD.collection_filter.collections[collection_handle].page_count = page_count;
        BOLD.collection_filter.collections[collection_handle].ajax_page_count = ajax_page_count;
        BOLD.collection_filter.money_format = data.money_format;
        BOLD.helpers.triggerCommonEvent('BOLD_COLLECTION_FILTERS_filters_loaded', null, {collection: collection_handle, product_count:data.product_count, page_count: page_count, ajax_page_count:ajax_page_count, all_filters: data.all_filters});
      }

    }, error_callback);
  },

  getMultipleCollectionProductPages:function(collection_handle, first_page, last_page){
    collection_handle = collection_handle || BOLD.collection_filter.getCurrentCollectionPage();
    if(typeof collection_handle != 'string'){
      return null;
    }
    BOLD.collection_filter.collections[collection_handle] = BOLD.collection_filter.collections[collection_handle] || {};
    first_page = first_page || 1;
    last_page = last_page || Math.ceil((BOLD.collection_filter.collections[collection_handle] ? BOLD.collection_filter.collections[collection_handle].product_count : 0) / (BOLD.collection_filter.pagination.products_per_page || 40));
    if(last_page < first_page){
      return;
    }
    BOLD.collection_filter.collections[collection_handle].pages_remaining = (BOLD.collection_filter.collections[collection_handle].pages_remaining || 0) + (last_page - first_page + 1)
    for(var page=first_page; page<=last_page; page++){
      // var decade = parseInt((page - first_page) / 10);
      // if(decade < 1){
        BOLD.collection_filter.getCollectionProductsByPage(collection_handle, page);
      // } else{
      //   (function(p, d) {
      //     setTimeout(function(){BOLD.collection_filter.getCollectionProductsByPage(collection_handle, p); }, 1500 * d);
      //   })(page, decade);
      // }
    }
  },

  getCollectionProductsByPage:function(collection_handle, page, success_callback, error_callback){
    collection_handle = collection_handle || BOLD.collection_filter.getCurrentCollectionPage();
    if(typeof collection_handle != 'string'){
      return null;
    }
    BOLD.helpers.get('/collections/' + collection_handle + '?view=json.filter.products&page=' + (page || 1), function(data){
      if(data && data.products && data.products.length){
        BOLD.collection_filter.collections[collection_handle] = (BOLD.collection_filter.collections[collection_handle] || {});
        //Since things are loaded asynchronously, page 1 might not be the first one returned. To prevent page flickers, give P1 a priority place in line

        if(data.page == 1){

          BOLD.collection_filter.collections[collection_handle].products = data.products.concat(BOLD.collection_filter.collections[collection_handle].products || []);
        }
        else{
          BOLD.collection_filter.collections[collection_handle].products = (BOLD.collection_filter.collections[collection_handle].products || []).concat(data.products);
        }
        BOLD.helpers.triggerCommonEvent('BOLD_COLLECTION_FILTERS_products_loaded', null, {collection: collection_handle, page: page, products: data.products, count:data.products.length});
        if ( BOLD.collection_filter.getURLParameter('collection') ) {
            BOLD.collection_filter.withURLonFirstLoad = true;          
            BOLD.collection_filter.reloadParamFilters();
        }      
      }

      if(data && data.products && data.products.length === 0){
        BOLD.helpers.triggerCommonEvent('BOLD_COLLECTION_FILTERS_empty_result', null, {page: page, products: data.products, count:data.products.length});
      }

      if(typeof success_callback === 'function'){
        success_callback(data);
      }
    }, error_callback);
  },
  updateRemainingPages:function(collection_handle, page){
    if(BOLD.collection_filter.collections[collection_handle] && BOLD.collection_filter.collections[collection_handle].pages_remaining > 0){
      BOLD.collection_filter.collections[collection_handle].pages_remaining --;
    }
  },

  getSelectedFiltersFromDom:function(filter_selector, selection_input_class){
    if(typeof filter_selector !== 'string'){
      filter_selector = BOLD.collection_filter.selectors.filter_header;
    }
    if(typeof selection_input_class !== 'string'){
      selection_input_class = BOLD.collection_filter.selectors.filter_input;
    }

    var filtersObj = {};

    var category_elements = document.querySelectorAll(filter_selector);
    for(var ce=0; ce<category_elements.length; ce++){
      var category_name = category_elements[ce].getAttribute('data-category');
      if(category_name){
        filtersObj[category_name] = [];
        var selection_elements = category_elements[ce].querySelectorAll(selection_input_class + ':checked');
        for(var se=0; se < selection_elements.length; se++){
          var selection_name = selection_elements[se].getAttribute('value');
          if(selection_name){
            filtersObj[category_name].push(selection_name);
          }
        }
      }
    }
    return filtersObj;
    BOLD.helpers.triggerCommonEvent('BOLD_COLLECTION_FILTERS_filters_updated', null, {filters: filtersObj});

  },
  getCurrentCollectionPage:function(){
    if(window.location.pathname.indexOf('/collections/') > -1){
      return window.location.pathname.split('/')[2];
    }
    return null;
  },
  updateCollectionFilters:function(collection_handle, products){
    collection_handle = collection_handle || BOLD.collection_filter.getCurrentCollectionPage();
    if(typeof collection_handle != 'string' || !products || !products.length){
      return null;
    }

    BOLD.collection_filter.collections[collection_handle] = BOLD.collection_filter.collections[collection_handle] || {};
    BOLD.collection_filter.collections[collection_handle].all_filters = BOLD.collection_filter.collections[collection_handle].all_filters || {};
    var all_filters = BOLD.collection_filter.collections[collection_handle].all_filters;

    for(var p=0; p<products.length; p++){
      var product = products[p];
      for(var category in product.filter_info){
        all_filters[category] = all_filters[category] || [];
        for(var v=0; v<product.filter_info[category].length; v++){
          var value = product.filter_info[category][v];
          if(all_filters[category].indexOf(value) === -1){
            all_filters[category].push(value);
            BOLD.helpers.triggerCommonEvent('BOLD_COLLECTION_FILTERS_filter_added', null, {collection: collection_handle, category:category, value:value});
          }
        }
      }
    }
  },

  updateFilters:function(collection_handle, data){
    collection_handle = collection_handle || BOLD.collection_filter.getCurrentCollectionPage();
    if(typeof collection_handle != 'string'){
      return null;
    }

    BOLD.collection_filter.collections[collection_handle] = (BOLD.collection_filter.collections[collection_handle] || {});

    if(data && data.category){
      BOLD.collection_filter.collections[collection_handle].applied_filters = BOLD.collection_filter.collections[collection_handle].applied_filters || {};
      if(data.selected && data.value){
        //Checkbox is checked - add the selected value to the appropriate category filter
        BOLD.collection_filter.collections[collection_handle].applied_filters[data.category] = BOLD.collection_filter.collections[collection_handle].applied_filters[data.category] || [];
        if(BOLD.collection_filter.collections[collection_handle].applied_filters[data.category].indexOf(data.value) == -1){
          BOLD.collection_filter.collections[collection_handle].applied_filters[data.category].push(data.value);
        }
      } else if(data && data.element && data.element.getAttribute('type') && data.element.getAttribute('type').toLowerCase() == 'text'){
        //Search box!  For now, we'll just apply these as a series of 'or' rules by splitting the entered text on the space character to get individual words
        BOLD.collection_filter.collections[collection_handle].applied_filters[data.category] = data.value.split(' ');
      }
      else if(data.value && BOLD.collection_filter.collections[collection_handle].applied_filters && BOLD.collection_filter.collections[collection_handle].applied_filters[data.category]) {
        //Not search and not selected - remove the value from the appropriate filter list (if it exists)
        var category_filters = BOLD.collection_filter.collections[collection_handle].applied_filters[data.category];
        var selection_index = category_filters.indexOf(data.value);
        if(selection_index > -1){
          category_filters.splice(selection_index, 1);
        }
      }
      
      var checkUserMedia = BOLD.collection_filter.checkUserMedia()

      if (!checkUserMedia) BOLD.helpers.triggerCommonEvent('BOLD_COLLECTION_FILTERS_selections_updated', null, {collection: collection_handle, selections:selections});      
    }
    else{
      var selections = BOLD.collection_filter.collections[collection_handle].applied_filters; // BOLD.collection_filter.getSelectedFiltersFromDom();
    }

    BOLD.collection_filter.paramAppliedFilters = BOLD.collection_filter.collections[collection_handle].applied_filters;
    return selections;
  },

  applyAllCollectionFilters:function(collection_handle){
    collection_handle = collection_handle || BOLD.collection_filter.getCurrentCollectionPage();
    if(!BOLD.collection_filter.collections[collection_handle]){
      return null;
    }

    var applied_filters = BOLD.collection_filter.collections[collection_handle].applied_filters;
    var all_products = BOLD.collection_filter.collections[collection_handle].products;

    var filtered_products = BOLD.collection_filter.applyFilters(all_products, applied_filters, collection_handle);
    BOLD.collection_filter.collections[collection_handle].filtered_products = filtered_products;
    BOLD.helpers.triggerCommonEvent('BOLD_COLLECTION_FILTERS_all_collection_filters_applied', null, {collection: collection_handle, filters:applied_filters, products:filtered_products});
    return filtered_products;
  },
  applyFilters:function(product_list, filters, collection_handle){
    if(!product_list || !filters){
      return product_list;
    }
    var filtered_products = [];
    for(var p=0; p<product_list.length; p++){
      var product = product_list[p];
      if(BOLD.collection_filter.productMeetsRequirements(product, filters)){
        filtered_products.push(product);
      }
    }
    BOLD.helpers.triggerCommonEvent('BOLD_COLLECTION_FILTERS_filters_applied', null, {collection: collection_handle, filters:filters, products:filtered_products});

    return filtered_products;
  },

  productMeetsRequirements:function(product, filter_rules){
    //Returns true if the product matches at least 1 rule in each category that has selections
    if(!product || !filter_rules){
      return null;
    }

    for(var category in filter_rules){
      var valuesArr = filter_rules[category];
      if(!valuesArr || !valuesArr.length){
        continue;
      }
      if(!product.filter_info || !product.filter_info[category]){
        return false;
      }

      var passes_any = false;
      for(var v=0; v<valuesArr.length && !passes_any; v++){
        if(product.filter_info[category].indexOf(valuesArr[v]) > -1){
          passes_any = true;
        }
        if(category == 'product_name'){
          //Special rule for the search box behaviour
          for(var n=0; n<product.filter_info[category].length; n++){
            var name = product.filter_info[category][n].toLowerCase();
            if(name.indexOf(valuesArr[v].toLowerCase()) > -1){
              passes_any = true;
            }
          }
        }
      }
      if(!passes_any){
        return false;
      }
    }
    return true;
  },
  updateProductCount:function(collection_handle, product_list){
    if(!product_list){
      return;
    }
    var filter_count = {};
    for(var p=0; p<product_list.length; p++){
      var product = product_list[p];
      for(var filter in product.filter_info){
        filter_count[filter] = filter_count[filter] || {};
        for(var v=0; v<product.filter_info[filter].length; v++){
          var value = product.filter_info[filter][v];
          if(value){
            filter_count[filter][value] = (filter_count[filter][value] ? filter_count[filter][value] + 1 : 1);
          }
        }
      }
    }
    BOLD.helpers.triggerCommonEvent('BOLD_COLLECTION_FILTERS_filter_count_updated', null, {collection:collection_handle, filter_count:filter_count});
    return filter_count;
  },
  countProductsExpandingFilter:function(collection_handle, category){
    collection_handle = collection_handle || BOLD.collection_filter.getCurrentCollectionPage();
    if(!collection_handle){
      return null;
    }
    var applied_filters = BOLD.collection_filter.collections[collection_handle].applied_filters;
    var filters_to_check = JSON.parse(JSON.stringify(applied_filters));
    delete filters_to_check[category];
    var all_products = BOLD.collection_filter.collections[collection_handle].products;
    var count = {};
    for(var p=0; p<all_products.length; p++){
      var product = all_products[p];
      if(BOLD.collection_filter.productMeetsRequirements(product, filters_to_check)){
        var category_values = product.filter_info[category];
        if(!category_values){
          continue;
        }
        for(var v=0; v<category_values.length; v++){
          var value = category_values[v];
          if(!value){
            continue;
          }
          count[value] = (typeof count[value] === 'number' ? count[value] + 1 : 1);
        }
      }
    }
    return count;
  },
  printProductCount:function(collection_handle, filter_count){
    collection_handle = collection_handle || BOLD.collection_filter.getCurrentCollectionPage();
    if(!collection_handle){
      return;
    }
    var applied_filters = BOLD.collection_filter.collections[collection_handle].applied_filters;
    var all_filters = BOLD.collection_filter.collections[collection_handle].all_filters;
    for(var category in all_filters){
      if(applied_filters && applied_filters[category] && applied_filters[category].length){
        var true_count = BOLD.collection_filter.countProductsExpandingFilter(collection_handle, category);
        for(var count_key in true_count){
          filter_count[category] = filter_count[category] || {};
          filter_count[category][count_key] = true_count[count_key];
        }
      }
      var total_category_products = 0;
      for(var v=0; v<all_filters[category].length; v++){
        var value = all_filters[category][v];
        if(!value){
          continue;
        }
        var product_count = (filter_count[category] && filter_count[category][value] ? filter_count[category][value] : 0);

        total_category_products += product_count;
        var countElement = document.querySelector('.bold-filter-count[data-collection="' + collection_handle + '"][data-category="' + category + '"][data-value="' + value + '"]');
        if(countElement){
          countElement.innerHTML = '(' + product_count + ')';
        }
        var rowElement = document.querySelector('.bold-filter-selection[data-collection="' + collection_handle + '"][data-category="' + category + '"][data-value="' + value + '"]');
        if(rowElement){
          rowElement.setAttribute('data-product-count', product_count);
          if(product_count == 0){
            //Make sure that potentially-invisible checkboxes are cleared and that the plugin is notified
            var checkbox = rowElement.querySelector('input');
            if(checkbox && checkbox.checked){
              checkbox.checked = false;
              BOLD.helpers.triggerCommonEvent('BOLD_COLLECTION_FILTERS_input_changed', null, {element: checkbox, selected: checkbox.checked, value: (checkbox.value || '').split('"').join('&quot;'), category: checkbox.getAttribute('data-category')});
            }
          }

        }
      }
      var categoryHeaderElement = document.querySelector('.bold-filter-header[data-collection="' + collection_handle + '"][data-category="' + category + '"]');
      var categoryViewAllElement = document.querySelector('.view-all[data-collection="' + collection_handle + '"][data-category="' + category + '"]');
      if(categoryHeaderElement){
        categoryHeaderElement.setAttribute('data-product-count', total_category_products);
      }
      if(categoryViewAllElement){
        categoryViewAllElement.setAttribute('data-product-count', total_category_products);
      }

    }
  },
setPaginationCount: function(pagination_count) {
 	//Set defaults, if required
	pagination_count = parseInt(pagination_count);
	if(!(pagination_count >= 1)){
		return;
	}
	BOLD.collection_filter.pagination.products_per_page = pagination_count;   
	for(var collection_handle in BOLD.collection_filter.collections) {
		var product_count = BOLD.collection_filter.collections[collection_handle].product_count
		BOLD.collection_filter.collections[collection_handle].page_count = Math.ceil(product_count / pagination_count);
		BOLD.collection_filter.updatePagination(collection_handle);
	}
},  
  updatePagination:function(collection_handle, page, product_list, pagination_count, display_area_selector){
    //Set defaults, if required
    collection_handle = collection_handle || BOLD.collection_filter.getCurrentCollectionPage();
    product_list = product_list || BOLD.collection_filter.collections[collection_handle].filtered_products;
    page = page || BOLD.collection_filter.collections[collection_handle].current_page || 1;
    pagination_count = pagination_count || BOLD.collection_filter.pagination.products_per_page;
    display_area_selector = display_area_selector || BOLD.collection_filter.selectors.pagination_display_area;

    var parent_container = document.querySelector(display_area_selector);
    if(!parent_container){
      return;
    }
    parent_container.innerHTML = BOLD.collection_filter.generatePaginationHTML(collection_handle, product_list, page, pagination_count);
  },
  generatePaginationHTML:function(collection_handle, product_list, page, pagination_count){
    //Set defaults, if required
    collection_handle = collection_handle || BOLD.collection_filter.getCurrentCollectionPage();
    product_list = product_list || BOLD.collection_filter.collections[collection_handle].filtered_products;
    page = page || 1;
    pagination_count = pagination_count || BOLD.collection_filter.pagination.products_per_page || 40;

    var page_count = (BOLD.collection_filter.collections[collection_handle].applied_filters ? Math.ceil(product_list.length / pagination_count) : BOLD.collection_filter.collections[collection_handle].page_count);
    if(page_count === 1){
      return '';
    }

    var paginationHTML = '';
    var prev_page = page - 1 || 1;
    var next_page = Math.min(page + 1, page_count);
    var navBtn = function(kind, targetPage, label, content) {
      return '<button type="button" class="bold-filter-pagination-' + kind + ' bold-collection-filter-pagination-selector" aria-label="' + label + '" data-page="' + targetPage + '" data-collection="' + collection_handle + '">' + content + '</button>';
    };
    var templates = BOLD.collection_filter.templates;
    var mergeData = {
      collection:collection_handle,
      page:page,
      first_page:1,
      prev_page:prev_page,
      next_page:next_page,
      last_page:page_count,
      first_page_link: page > 1 ? navBtn('first', 1, 'First page', templates.pagination_first) : '',
      prev_page_link: page > 1 ? navBtn('prev', prev_page, 'Previous page', templates.pagination_prev) : '',
      next_page_link: page < page_count ? navBtn('next', next_page, 'Next page', templates.pagination_next) : '',
      last_page_link: page < page_count ? navBtn('last', page_count, 'Last page', templates.pagination_last) : ''
    }
    var paginationRules = BOLD.collection_filter.pagination;
    var skipping_pages = false;
    //Start with the header
    paginationHTML +=BOLD.collection_filter.mergeTemplateFields(BOLD.collection_filter.templates.pagination_header, mergeData);

    //Print all the relevant page numbers
    for(var pageNum = 1; pageNum <= page_count && pageNum < 10000; pageNum++){
      if(pageNum > paginationRules.min_pages_at_beginning && pageNum < (page_count - paginationRules.min_pages_at_end) && Math.abs(pageNum - page) > paginationRules.pages_surrounding_current){
        //Page falls outside the range of what we want to print
        if(!skipping_pages){
          paginationHTML += BOLD.collection_filter.templates.pagination_break;
          skipping_pages = true;
        }
        continue;
      }
      skipping_pages=false;
      mergeData.page_number = pageNum;
      paginationHTML +=  BOLD.collection_filter.mergeTemplateFields((pageNum === page ? BOLD.collection_filter.templates.pagination_current_page_prefix : BOLD.collection_filter.templates.pagination_element_prefix) + BOLD.collection_filter.templates.pagination_element + (pageNum === page ? BOLD.collection_filter.templates.pagination_current_page_suffix : BOLD.collection_filter.templates.pagination_element_suffix), mergeData);
    }

    //Finish with the footer
    paginationHTML += BOLD.collection_filter.mergeTemplateFields(BOLD.collection_filter.templates.pagination_footer, mergeData);
    return paginationHTML;
  },

  getResultCount: function(collection_handle) {
    collection_handle = collection_handle || BOLD.collection_filter.getCurrentCollectionPage();
    if (!BOLD.collection_filter.collections[collection_handle]) {
      return 0;
    }
    
    var product_list = BOLD.collection_filter.collections[collection_handle].filtered_products || BOLD.collection_filter.collections[collection_handle].products;
    return product_list ? product_list.length : 0;
  },

  updateResultCount: function(collection_handle) {
    var count = BOLD.collection_filter.getResultCount(collection_handle);
    var countElement = document.querySelector('#filter-product-count');
    if (countElement) {
      countElement.innerHTML = count;
    }
  },

  clearAndPrintAllProducts:function(collection_handle, page, pagination_count, display_area_selector){
    collection_handle = collection_handle || BOLD.collection_filter.getCurrentCollectionPage();
    var starting_index = ((page || 1) - 1) * (pagination_count || BOLD.collection_filter.pagination.products_per_page || 40);
    BOLD.collection_filter.clearProducts(collection_handle, display_area_selector);
    BOLD.collection_filter.printProductsWithOffset(collection_handle, starting_index, pagination_count, display_area_selector);
    BOLD.collection_filter.updateResultCount(collection_handle);
  },
  clearProducts:function(collection_handle, display_area_selector){
    display_area_selector = display_area_selector || BOLD.collection_filter.selectors.product_display_area;
    var parent_container = document.querySelector(display_area_selector);

    if(!parent_container){
      BOLD.helpers.triggerCommonEvent('BOLD_COLLECTION_FILTERS_no_print_area', null, {collection:collection_handle, selector:display_area_selector});
      return;
    }

    parent_container.innerHTML = '';
    BOLD.helpers.triggerCommonEvent('BOLD_COLLECTION_FILTERS_display_cleared', null, {element:parent_container});
  },
  printProductsWithOffset:function(collection_handle, starting_index, pagination_count, display_area_selector){
    pagination_count = pagination_count || BOLD.collection_filter.pagination.products_per_page;
    if(typeof starting_index !== 'number'){
      starting_index = 0;
    }
    if(!BOLD.collection_filter.collections[collection_handle]){
      return;
    }
    var printArea = document.querySelector((display_area_selector || BOLD.collection_filter.selectors.product_display_area));
    var product_list = BOLD.collection_filter.applyAllCollectionFilters(collection_handle) || BOLD.collection_filter.collections[collection_handle].products;

    if(!product_list[starting_index]){
      BOLD.helpers.triggerCommonEvent('BOLD_COLLECTION_FILTERS_no_products', null, {starting_index:starting_index, results:product_list, pagination_count:pagination_count, element:printArea});
    }

    BOLD.collection_filter.collections[collection_handle].products_displayed = 0;
    for(var index=starting_index; index < (starting_index + pagination_count) && index < product_list.length; index++){
      BOLD.collection_filter.printSingleProduct(product_list[index], printArea)
      BOLD.collection_filter.collections[collection_handle].products_displayed ++;
    }
  },
  printSingleProduct:function(product, containing_element){
    var fmt = BOLD.collection_filter.money_format;
    var isOnSale = product.compare_at_price && product.compare_at_price > product.price;
    var isSoldOut = !product.available;
    var saleBadgeHtml = '<div class="absolute left-0 top-0 inline-flex h-5 min-w-14 items-center justify-center bg-primary-300 px-2"><p class="justify-center text-center text-xs font-bold leading-none text-white"><span class="badge__text">Sale</span></p></div>';
    var soldOutBadgeHtml = '<div class="absolute top-0 h-full max-h-full w-full max-w-full overflow-hidden xl:h-[230px] xl:max-h-[230px] xl:w-[230px] xl:max-w-[230px]"><div class="absolute left-0 top-0 h-full max-h-full w-full max-w-full bg-white opacity-40 xl:h-[230px] xl:max-h-[230px] xl:w-[230px] xl:max-w-[230px]"></div><div class="absolute bottom-auto left-1/2 right-auto top-1/2 inline-flex h-5 min-w-14 -translate-x-1/2 -translate-y-1/2 transform items-center justify-center bg-gray-100 px-2"><p class="justify-center text-center text-xs font-bold leading-none text-black"><span class="badge__text">Sold Out</span></p></div></div>';
    var extraFields = {
      price_formatted: BOLD.helpers.formatMoney(product.price, fmt),
      on_sale_class: isOnSale ? ' on-sale' : '',
      sold_out_class: isSoldOut ? ' sold-out' : '',
      sale_badge: isOnSale ? saleBadgeHtml : '',
      sold_out_badge: isSoldOut ? soldOutBadgeHtml : '',
      compare_price_html: isOnSale ? '<div class="justify-center text-sm font-normal leading-none text-black line-through opacity-70"><span class="grid-link__sale_price">' + BOLD.helpers.formatMoney(product.compare_at_price, fmt) + '</span></div>' : ''
    };
    if ( view == 'list' ) {
      containing_element.innerHTML += BOLD.collection_filter.mergeTemplateFields(BOLD.collection_filter.templates.product_list, product, extraFields);
    } else {
      containing_element.innerHTML += BOLD.collection_filter.mergeTemplateFields(BOLD.collection_filter.templates.product_grid, product, extraFields);
    }
    BOLD.helpers.triggerCommonEvent('BOLD_COLLECTION_FILTERS_product_printed', null, {product:product, containing_element:containing_element});
  },

  printFilters:function(collection_handle, display_area_selector){
    display_area_selector = display_area_selector || BOLD.collection_filter.selectors.filter_display_area;
    var filter_elements = document.querySelectorAll(display_area_selector);


    if(!filter_elements.length){
      BOLD.helpers.triggerCommonEvent('BOLD_COLLECTION_FILTERS_filter_element_not_found', null, {selector:display_area_selector});
      return;
    }

    var filterHTML = BOLD.collection_filter.generateFilterHTML(collection_handle);
    for(var e=0; e<filter_elements.length; e++){
      filter_elements[e].innerHTML = filterHTML;
    }
    BOLD.helpers.triggerCommonEvent('BOLD_COLLECTION_FILTERS_filters_drawn', null, {collection:collection_handle, filter_elements:filter_elements, filter_HTML: filterHTML});

    BOLD.collection_filter.addFilterApplyButton()
  },
  printFilterUpdate:function(collection_handle, category, value, display_area_selector){
    if(category == 'product_name'){
      return;
    }
    display_area_selector = display_area_selector || BOLD.collection_filter.selectors.filter_display_area;
    var filter_elements = document.querySelectorAll(display_area_selector);

    if(!filter_elements.length){
      BOLD.helpers.triggerCommonEvent('BOLD_COLLECTION_FILTERS_filter_element_not_found', null, {selector:display_area_selector});
      return;
    }

    for(var e=0; e<filter_elements.length; e++){
      var element = filter_elements[e]
      var category_element = element.querySelector('.bold-filter-wrapper[data-category="' + category + '"][data-collection="' + collection_handle + '"]');
      var display_val = value.replace('-', ' ');

      if(category_element){
        var container = document.createElement('div');
        container.innerHTML = BOLD.collection_filter.generateSingleFilterHTML({collection:collection_handle, category:category, value:value, display_val:display_val });
        for(var c=0; c<container.children.length; c++){
          category_element.appendChild(container.children[c]);
        }
      }else{
        var container = document.createElement('div');
        container.innerHTML = BOLD.collection_filter.generateEmptyFilterCategoryHTML(collection_handle, category);
        var wrapper = container.querySelector('.bold-filter-wrapper[data-category="' + category + '"][data-collection="' + collection_handle + '"]');
        if(wrapper){
          wrapper.innerHTML = BOLD.collection_filter.generateSingleFilterHTML({collection:collection_handle, category:category, value:value, display_val:display_val });
        }
        for(var c=0; c<container.children.length; c++){
          element.appendChild(container.children[c]);
        }
      }
    }
  },

  generateFilterHTML:function(collection_handle){

    if(!BOLD.collection_filter.collections[collection_handle] || !BOLD.collection_filter.collections[collection_handle].all_filters){
      BOLD.helpers.triggerCommonEvent('BOLD_COLLECTION_FILTERS_no_filter_data', null, {collection:collection_handle});
      return;
    }

    var generatedHTML = BOLD.collection_filter.mergeTemplateFields(BOLD.collection_filter.templates.filter_search, {collection:collection_handle});;
    var all_filters = BOLD.collection_filter.collections[collection_handle].all_filters;

    for(var category in all_filters){
      if(category == 'product_name'){
        continue;
      }
      var valuesArr = all_filters[category];
      if(category.toLowerCase() == 'title' || category.toLowerCase == 'description' || !valuesArr.length){
        continue;
      }

      var mergeData = {
        category:category,
        collection:collection_handle
      };

      generatedHTML += BOLD.collection_filter.mergeTemplateFields(BOLD.collection_filter.templates.filter_header_toggle, mergeData);

      for(var v=0; v<valuesArr.length; v++){
        var value = valuesArr[v];
        if(!value){
          continue;
        }
         mergeData.value = value;

        if ( mergeData.category == 'width' ) {

          mergeData.display_val = value;
        } else {

          mergeData.display_val = value.replace('-',' ');
        }

        generatedHTML += BOLD.collection_filter.generateSingleFilterHTML(mergeData);
      }
      generatedHTML += BOLD.collection_filter.mergeTemplateFields(BOLD.collection_filter.templates.filter_footer, mergeData)
    }
    return generatedHTML;
  },
  generateEmptyFilterCategoryHTML:function(collection_handle, category){
    var mergeData = {
      category:category,
      collection:collection_handle
    }
    return BOLD.collection_filter.mergeTemplateFields(BOLD.collection_filter.templates.filter_header, mergeData) + BOLD.collection_filter.mergeTemplateFields(BOLD.collection_filter.templates.filter_footer, mergeData);
  },
  generateSingleFilterHTML:function(mergeData){

    // replace mergeData

    var countspan = BOLD.collection_filter.mergeTemplateFields(BOLD.collection_filter.templates.filter_count, mergeData);
    var checkbox = BOLD.collection_filter.mergeTemplateFields(BOLD.collection_filter.templates.filter_checkbox_custom, mergeData);
    var elementHTML = BOLD.collection_filter.mergeTemplateFields(BOLD.collection_filter.templates.filter_template_new, mergeData, {count:countspan, checkbox:checkbox});
    return elementHTML;

  },
  mergeTemplateFields:function(template, sources){
    if(typeof template !== 'string'){
      return '';
    }
    for(var a=1; a<arguments.length; a++){
      var source = arguments[a];
      for(var field in source){
        var value = source[field];
        if(typeof value === 'object' || typeof value === 'function'){
          continue;
        }
        var text_to_find = '[' + field + ']';
        template = template.split(text_to_find).join(source[field]);
      }
    }
    return template;
  },
  generateFilterQuerystring:function(collection_handle){
    collection_handle = collection_handle || BOLD.collection_filter.getCurrentCollectionPage();
  },
  parseFilterQuerystring:function(collection_handle, querystring){
    collection_handle = collection_handle || BOLD.collection_filter.getCurrentCollectionPage();
    querystring = querystring || window.location.search;
    //Strip out a leading '?', if supplied, then split on the ampersand
    query_arr = (qstr[0] === '?' ? qstr.substr(1) : qstr).split('&');
    var filter_obj = {};
    for(var q=0; q < query_arr.length; q++){
      var kv_pair = query_arr[q].split('=');
      if(kv_pair[0] && kv_pair[1]){
        var key = decodeURIComponent(kv_pair[0]), value=decodeURIComponent(kv_pair[1]);


      }
    }
},
  hideSubCollectionSection: function() {
        $('.collection_featured_links').hide();
        $('.rte.rte--header').hide();
        $('.collection_featured_links').next('hr').hide();
        $('.collection_featured_title').hide();
        $('.collection-header').text( $('.collection_featured_title').text() );    
  },
  replaceUrlParam: function(paramName, paramValue) {
      //  debugger;
    var pattern = new RegExp('('+paramName+'=).*?(&|$)'),
        url = decodeURIComponent(window.location.href),
        newUrl = url.replace(pattern,'$1' + paramValue + '$2');
    if ( newUrl == url ) {
      newUrl = newUrl + (newUrl.indexOf('?')>0 ? '&' : '?') + paramName + '=' + paramValue;
    }
    return newUrl;
  },
  getURLCurrentPath: function(){
    var theCurrentURL = decodeURIComponent(window.location.href);
      if ( theCurrentURL.indexOf('?collection=') > -1 ) {
        var urlSplitSplit = theCurrentURL.split('?'),
        thePathUrl = urlSplitSplit[1];
      } else {
        var thePathUrl = ''
      }
    return thePathUrl;
  },
  getURLParameter: function(sParam) {
      var sPageURL = decodeURIComponent(window.location.href);
      if ( sPageURL.indexOf('?collection=') > -1 ) {
        var sPageURLHashtagRemove = sPageURL.split('?'),
        sURLVariables = sPageURLHashtagRemove[1].split('&'),
        sParameterName,
        i;

        for (i = 0; i < sURLVariables.length; i++) {
          sParameterName = sURLVariables[i].split('=');

          if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : sParameterName[1];
          }
        }
      } else {
        return undefined;
      }

  },
  swapParametersOnEvent: function(pamCollection, pamName, pamValue) {
      var boldParamURLHash = '', boldOriginalURL = '';

      if ( BOLD.collection_filter.getURLParameter(pamName) ) {
          var originalPamNameValue = BOLD.collection_filter.getURLParameter(pamName);
          var boldParamURL = window.location.href.replace("&"+pamName+"="+originalPamNameValue,''),
          //var boldParamURL = BOLD.collection_filter.replaceUrlParam(pamName, pamValue),
              boldParamURLArray = boldParamURL.split('?');
              boldParamURLHash = boldParamURLArray[1];

              boldParamURLHash = boldParamURLHash+'&'+pamName+'='+pamValue;

              if ( pamName == 'by' && boldParamURLHash.indexOf('page=') > -1 ) {
                  boldParamURLHash = boldParamURLHash.replace('page='+BOLD.collection_filter.getURLParameter('page'), "page=1");
              }
      } else if ( BOLD.collection_filter.getURLParameter('collection') ) {
          boldParamURLHash = BOLD.collection_filter.getURLCurrentPath()+'&'+pamName+'='+pamValue;
      } else {
          boldParamURLHash = 'collection='+pamCollection+'&'+pamName+'='+pamValue;
      }

      window.history.pushState('', '', '/collections/'+pamCollection+'?'+ boldParamURLHash);
      //window.location.hash = boldParamURLHash;
  },
  setParamFilters: function(the_filter) {

    var concatFilterToString = '';
    for(var category in the_filter){

      var valuesArr = the_filter[category];
      if(!valuesArr || !valuesArr.length){
        continue;
      }


      for(var v=0; v<valuesArr.length; v++){
          concatFilterToString += ( category + '__'+valuesArr[v] ) + '+';
      }
    }

    return concatFilterToString.slice(0, -1);
  },
  reloadParamFilters: function() {

      if ( BOLD.collection_filter.getURLParameter('collection') ) {
          var parameterFilterArray = [];
          BOLD.collection_filter.forURLParameter.parameterCollection = BOLD.collection_filter.getURLParameter('collection');
          BOLD.collection_filter.forURLParameter.parameterPagination = BOLD.collection_filter.getURLParameter('page') || 1;
          BOLD.collection_filter.forURLParameter.parameterShowBy = BOLD.collection_filter.getURLParameter('by') || 40;
          BOLD.collection_filter.forURLParameter.parameterViewBy = BOLD.collection_filter.getURLParameter('view') || 'grid';
          BOLD.collection_filter.forURLParameter.parameterSortBy = BOLD.collection_filter.getURLParameter('sort') || 'featured';
          // BOLD.collection_filter.forURLParameter.parameterFilterBy = BOLD.collection_filter.getURLParameter('filter') || '';
          BOLD.collection_filter.collections[BOLD.collection_filter.forURLParameter.parameterCollection].current_page = BOLD.collection_filter.getURLParameter('page') || 1;
          if ( BOLD.collection_filter.getURLParameter('filter') ) {
            BOLD.collection_filter.collections[BOLD.collection_filter.forURLParameter.parameterCollection].applied_filters = {};
            $('.bold-collection-filters').find('.bold-filter-checkbox:checkbox:checked').prop('checked', false);
            if (BOLD.collection_filter.getURLParameter('filter').indexOf('+') > -1) {
                parameterFilterArray = BOLD.collection_filter.getURLParameter('filter').split('+');
                    var paramCatKey = '',
                    paramCatValue = '';
                  $.each(parameterFilterArray, function(key, value) {
                      var parameterFilterArrayValue = value.split('__'),
                          paramCatKey = parameterFilterArrayValue[0],
                          paramCatValue = parameterFilterArrayValue[1],
                          forSelectorPurposeOnly = paramCatKey + '-' + paramCatValue;
                      BOLD.collection_filter.updatedParamFilters(BOLD.collection_filter.forURLParameter.parameterCollection, paramCatKey, paramCatValue);
                      $('.bold-collection-filters').find('.bold-filter-checkbox[data-inputfilter="'+forSelectorPurposeOnly+'"]').prop('checked', true);
                  })

            } else {
                parameterFilterArray = BOLD.collection_filter.getURLParameter('filter');
                var parameterFilterArrayValue = parameterFilterArray.split('__'),
                    paramCatKey = parameterFilterArrayValue[0],
                    paramCatValue = parameterFilterArrayValue[1],
                    forSelectorPurposeOnly = paramCatKey + '-' + paramCatValue;
                BOLD.collection_filter.updatedParamFilters(BOLD.collection_filter.forURLParameter.parameterCollection, paramCatKey, paramCatValue);
                $('.bold-collection-filters').find('.bold-filter-checkbox[data-inputfilter="'+forSelectorPurposeOnly+'"]').prop('checked', true);
            }

          }
          
          BOLD.collection_filter.hideSubCollectionSection();
          BOLD.collection_filter.updatedParamFilters(BOLD.collection_filter.forURLParameter.parameterCollection, null, BOLD.collection_filter.forURLParameter.parameterFilterBy);


	    // update Pagination
	    BOLD.collection_filter.setPaginationCount(BOLD.collection_filter.forURLParameter.parameterShowBy);

          //BOLD.collection_filter.updatePagination(BOLD.collection_filter.forURLParameter.parameterCollection, BOLD.collection_filter.forURLParameter.parameterPagination);
          if(BOLD.collection_filter.collections[BOLD.collection_filter.forURLParameter.parameterCollection].current_page != BOLD.collection_filter.forURLParameter.parameterPagination){
            BOLD.collection_filter.collections[BOLD.collection_filter.forURLParameter.parameterCollection].current_page = BOLD.collection_filter.forURLParameter.parameterPagination;
            BOLD.collection_filter.clearAndPrintAllProducts(BOLD.collection_filter.forURLParameter.parameterCollection, BOLD.collection_filter.forURLParameter.parameterPagination);
          }


          // view By
          BOLD.collection_filter.pagination.products_per_page = BOLD.collection_filter.getURLParameter('by') || 40;
          var filtered_products = BOLD.collection_filter.applyFilters(BOLD.collection_filter.collections[BOLD.collection_filter.forURLParameter.parameterCollection].products, BOLD.collection_filter.collections[BOLD.collection_filter.forURLParameter.parameterCollection].applied_filters, BOLD.collection_filter.forURLParameter.parameterCollection);
          BOLD.collection_filter.collections[BOLD.collection_filter.forURLParameter.parameterCollection].filtered_products = filtered_products;
          BOLD.helpers.triggerCommonEvent('BOLD_COLLECTION_FILTERS_viewby_changed', null, {collection: BOLD.collection_filter.forURLParameter.parameterCollection, filters: BOLD.collection_filter.collections[BOLD.collection_filter.forURLParameter.parameterCollection].applied_filters, products:filtered_products});
          $('#ViewBy').val(BOLD.collection_filter.pagination.products_per_page);

          //$('.bold-product-display').scrollTop(0);
          document.body.scrollTop = document.documentElement.scrollTop = 0;
        //  $.scrollTop();
      }
  },
  updatedParamFilters:function(collection_handle, dataCategory, dataValue){


    //BOLD.helpers.triggerCommonEvent('BOLD_COLLECTION_FILTERS_input_changed', null,
    //{element: checkbox, selected: checkbox.checked, value: (checkbox.value || '').split('"').join('&quot;'), category: checkbox.getAttribute('data-category')});
    collection_handle = BOLD.collection_filter.forURLParameter.parameterCollection;
    if(typeof collection_handle != 'string'){
      return null;
    }

    BOLD.collection_filter.collections[collection_handle] = (BOLD.collection_filter.collections[collection_handle] || {});

    if(dataCategory && dataValue){
      BOLD.collection_filter.collections[collection_handle].applied_filters = BOLD.collection_filter.collections[collection_handle].applied_filters || {};

        BOLD.collection_filter.collections[collection_handle].applied_filters[dataCategory] = BOLD.collection_filter.collections[collection_handle].applied_filters[dataCategory] || [];
        if(BOLD.collection_filter.collections[collection_handle].applied_filters[dataCategory].indexOf(dataValue) == -1){
          BOLD.collection_filter.collections[collection_handle].applied_filters[dataCategory].push(dataValue);
        }

        
        var checkUserMedia = BOLD.collection_filter.checkUserMedia()

        if (!checkUserMedia) {
          BOLD.helpers.triggerCommonEvent('BOLD_COLLECTION_FILTERS_selections_updated', null, {
            collection: collection_handle, 
            selections: BOLD.collection_filter.collections[collection_handle].applied_filters
          });
        }

        BOLD.collection_filter.clearAndPrintAllProducts(collection_handle, BOLD.collection_filter.collections[collection_handle].current_page);
        BOLD.collection_filter.updatePagination(collection_handle, BOLD.collection_filter.collections[collection_handle].current_page);
    }
    else{
      var selections = BOLD.collection_filter.collections[collection_handle].applied_filters; // BOLD.collection_filter.getSelectedFiltersFromDom();
    }


    return selections;
  },
  addFilterApplyButton: function() {
    $('.filter-apply-wrapper').remove();
    var filter_apply = $('<button>', {
      id: 'MobileFilterApply',
      class: 'btn btn-secondary mobile-filter-apply justify-start text-white text-sm font-bold leading-none w-[100px] h-[34px] p-2 bg-brand rounded-[3px] inline-flex justify-center items-center gap-2 overflow-hidden',
      text: 'Apply'
    });

    filter_apply.on('click', function() {
      var current_collection = BOLD.collection_filter.getCurrentCollectionPage();
      var selections = BOLD.collection_filter.collections[current_collection].applied_filters;
      
      BOLD.helpers.triggerCommonEvent('BOLD_COLLECTION_FILTERS_selections_updated', null, {
        collection: current_collection, 
        selections: selections
      });
      
      $('#MobileFilterClose').fadeToggle('fast');
      $('#MobileFilter').slideToggle(220);
      $('.filter-menu-container').slideToggle(220);
      
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });

    var filter_wrapper = $('<div>', {
      class: 'filter-apply-wrapper lg:hidden block block p-3 inline-flex flex-col justify-start items-start gap-2.5 w-full bg-white'
    }).append(filter_apply);

    var filter_display_area = BOLD.collection_filter.selectors.filter_display_area;
    var filter_elements = document.querySelectorAll(filter_display_area);

    filter_elements.forEach(function(el) {
      $(el).append(filter_wrapper.clone(true)); 
    });
  },
  checkUserMedia: function() {
    var ua = navigator.userAgent.toLowerCase();
    var userMedia = window.matchMedia("(max-width: 767px)").matches;
    var isMobileDetected = false;

    if (userMedia || /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/.test(ua)) {
      isMobileDetected = true;
    } 

    return isMobileDetected
  }
}


/*
if (history.replaceState) {
    var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?myNewUrlQuery=1';
    window.history.replaceState({path:newurl},'',newurl);
}
*/

/* ***************************************************************************************************
		Event Listeners
 *************************************************************************************************** */

document.addEventListener('DOMContentLoaded', function(){
  var current_collection_page = BOLD.collection_filter.getCurrentCollectionPage();
  if(typeof current_collection_page !== 'string'){
    return;
  }
  BOLD.collection_filter.getMultipleCollectionProductPages(current_collection_page, 1, BOLD.collection_filter.pagination.preload_page_count);
  BOLD.collection_filter.getFilterInfo(current_collection_page);

});

window.onpopstate = function (event) {
      if(BOLD.collection_filter.hasChangeLastLinkEvent != window.location.href){
        if ( BOLD.collection_filter.getURLParameter('collection') ) {
            BOLD.collection_filter.hasChangeLastLinkEvent = window.location.href;
            BOLD.collection_filter.reloadParamFilters();
        } else {
            location.reload();
        }
      }
      document.body.scrollTop = document.documentElement.scrollTop = 0;
}

document.addEventListener('change', function(evt){
  if(evt && evt.target && evt.target.className && evt.target.className.indexOf('bold-filter-input') > -1){
    BOLD.collection_filter.withURLonFirstLoad = false;
    BOLD.helpers.triggerCommonEvent('BOLD_COLLECTION_FILTERS_input_changed', null, {element: evt.target, selected: evt.target.checked, value: (evt.target.value || '').split('"').join('&quot;'), category: evt.target.getAttribute('data-category')});
    BOLD.collection_filter.hasChangeLastLinkEvent = window.location.href;
  }

});

//Toggle filter accordians
document.addEventListener('click', function(evt){
  var target = evt.target;
  var boldFilterHeader = target.parentElement;
  var isIcomoon = target.classList.contains('icomoon');

  target = isIcomoon ? boldFilterHeader : evt.target; // to trigger icomoon click
  if(!target.parentElement || !target.className || !(target.className.indexOf('bold-filter-header') > -1 || target.className.indexOf('bold-collection-filter-pagination-selector') > -1)){
    return;
  }
  //Accordian code
  if(target.className.indexOf('bold-filter-header') > -1){    
    if(target.parentElement.className && target.parentElement.className.indexOf('bold-filter-active') > -1){
      target.parentElement.className = target.parentElement.className.split('bold-filter-active').join(' ').split('  ').join(' ').trim();
    }else{
      target.parentElement.className = ((target.parentElement.className || '') + ' bold-filter-active').trim();
    }
  }

  //Pagination code
  if(target.className.indexOf('bold-collection-filter-pagination-selector') > -1){
    BOLD.collection_filter.swapParametersOnEvent(evt.target.getAttribute('data-collection'), 'page', evt.target.getAttribute('data-page'));
    BOLD.helpers.triggerCommonEvent('BOLD_COLLECTION_FILTERS_page_changed', evt, {element: evt.target, collection: (evt.target.getAttribute('data-collection') || ''), page: parseInt(evt.target.getAttribute('data-page')), category: evt.target.getAttribute('data-category')});
    BOLD.collection_filter.hasChangeLastLinkEvent = '?'+BOLD.collection_filter.getURLCurrentPath();
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }

});

BOLD.common.eventEmitter.on('BOLD_COLLECTION_FILTERS_filters_loaded', function(a){
  if(!a || !a.data){
    return;
  }
  BOLD.collection_filter.printFilters(a.data.collection);
  BOLD.collection_filter.getMultipleCollectionProductPages(a.data.collection, BOLD.collection_filter.pagination.preload_page_count + 1, a.data.ajax_page_count);
  BOLD.collection_filter.updatePagination(a.data.collection);
  BOLD.helpers.triggerCommonEvent('BOLD_COLLECTION_FILTERS_filter_name_change');
  BOLD.helpers.triggerCommonEvent('BOLD_COLLECTION_FILTERS_filter_view_change');
  BOLD.helpers.triggerCommonEvent('BOLD_COLLECTION_FILTERS_filter_viewby_change');
  BOLD.helpers.triggerCommonEvent('BOLD_COLLECTION_FILTERS_filter_sortby_change');

});

BOLD.common.eventEmitter.on('BOLD_COLLECTION_FILTERS_filter_view_change', function() {
    $('.change-view').on('click', function() {
          var current_collection_page = BOLD.collection_filter.getCurrentCollectionPage();
          var applied_filters = BOLD.collection_filter.collections[current_collection_page].applied_filters;
          var all_products = BOLD.collection_filter.collections[current_collection_page].products;
          var filtered_products = BOLD.collection_filter.applyFilters(all_products, applied_filters, current_collection_page);
          BOLD.collection_filter.collections[current_collection_page].filtered_products = filtered_products;

        BOLD.helpers.triggerCommonEvent('BOLD_COLLECTION_FILTERS_view_changed', null, {collection: current_collection_page, filters:applied_filters, products:filtered_products});
        $(this).addClass('change-view--active');
        $(this).siblings('.change-view').removeClass('change-view--active');
        BOLD.collection_filter.hasChangeLastLinkEvent = '?'+BOLD.collection_filter.getURLCurrentPath();
    });
});

BOLD.common.eventEmitter.on('BOLD_COLLECTION_FILTERS_filter_sortby_change', function() {
  $('#SortBy').bind('change', function(e) {
    	e.preventDefault();
      var current_collection_page = BOLD.collection_filter.getCurrentCollectionPage();
      var applied_filters = BOLD.collection_filter.collections[current_collection_page].applied_filters;
      var all_products = BOLD.collection_filter.collections[current_collection_page].products;
      var filtered_products = BOLD.collection_filter.applyFilters(all_products, applied_filters, current_collection_page);
      BOLD.collection_filter.collections[current_collection_page].filtered_products = filtered_products;

      var currObject = BOLD.collection_filter.collections[current_collection_page].filtered_products;

      BOLD.helpers.triggerCommonEvent('BOLD_COLLECTION_FILTERS_sort_changed', null, {collection: current_collection_page, filters:applied_filters, products:filtered_products});
      BOLD.collection_filter.hasChangeLastLinkEvent = '?'+BOLD.collection_filter.getURLCurrentPath();
  });

});

BOLD.common.eventEmitter.on('BOLD_COLLECTION_FILTERS_filter_viewby_change', function() {
  $('#ViewBy').bind('change', function() {
    BOLD.collection_filter.setPaginationCount($(this).val());
    var current_collection_page = BOLD.collection_filter.getCurrentCollectionPage();
    var applied_filters = BOLD.collection_filter.collections[current_collection_page].applied_filters;
    var all_products = BOLD.collection_filter.collections[current_collection_page].products;
    var filtered_products = BOLD.collection_filter.applyFilters(all_products, applied_filters, current_collection_page);
    BOLD.collection_filter.collections[current_collection_page].current_page = 1;
    BOLD.collection_filter.pagination.ajax_products_per_page = BOLD.collection_filter.pagination.products_per_page;
    BOLD.collection_filter.collections[current_collection_page].filtered_products = filtered_products;
    BOLD.collection_filter.swapParametersOnEvent(current_collection_page, 'by', BOLD.collection_filter.pagination.products_per_page);
    BOLD.helpers.triggerCommonEvent('BOLD_COLLECTION_FILTERS_viewby_changed', null, {collection: current_collection_page, filters:applied_filters, products:filtered_products});
    BOLD.collection_filter.hasChangeLastLinkEvent = '?'+BOLD.collection_filter.getURLCurrentPath();
  });

});

BOLD.common.eventEmitter.on('BOLD_COLLECTION_FILTERS_filter_name_change', function() {
        var filterWidthJSON = '//silkflowersfactory.com/cdn/shop/t/155/assets/filter-new-name.js?v=134648024708907843151778834365';
        $.ajax({
            type: 'GET',
            url: filterWidthJSON,
            dataType: 'json',
            success: function(results) {
                $.each(results, function( resKey, resVal ) {

                  if ( resKey.indexOf("filter-title") > -1 ) {
                      $.each(results[resKey], function( filterTitleKey, filterTitleVal ) {
                            if ( $('ul.bold-filter-wrapper[data-category="'+ filterTitleKey +'"]').length > 0 ) {
                                $('p.bold-filter-header[data-category="'+ filterTitleKey +'"]').html(filterTitleVal +
                                  '<span class="icon icon-circle-plus" style="font-family: launch-icons, sans-serif;">+</span><span class="icon icon-circle-minus heading-active" style="font-family: launch-icons, sans-serif; display: none">–</span>'
                                );
                            }
                      })

                  } else {

                      var resultKey = resKey;
                      if ( $('ul.bold-filter-wrapper[data-category="'+ resKey +'"]').length > 0 ) {
                          $('ul.bold-filter-wrapper[data-category="'+resKey+'"]').find('li').each(function() {

                              var $this = $(this),
                                  $thisText = $this.find('label .special-name').attr('data-special-name');
                                  if ( results[resKey].hasOwnProperty($thisText) ) {
                                      var theSpecialNameText = results[resKey][$thisText];
                                        if ( theSpecialNameText.toLowerCase() === 'hidden' ) {
                                            $this.hide();
                                        } else {
                                            $this.find('label .special-name').text(results[resKey][$thisText]);
                                        }
                                  }
                          });
                      }

                  }
                })
             }
        });


      $('span.icon, span.icomoon').on('click', function() {
         $(this).parents('p.bold-filter-header').click();
         $(this).parents('p.bold-filter-header').closest('.bold-filter').toggleClass('bold-filter-active');
      })
});

BOLD.common.eventEmitter.on('BOLD_COLLECTION_FILTERS_products_loaded', function(a){
  if(!a || !a.data || !BOLD.collection_filter.collections[a.data.collection]){
    return;
  }
  BOLD.collection_filter.updateRemainingPages(a.data.collection, a.data.page);
    BOLD.collection_filter.applyAllCollectionFilters(a.data.collection);
    BOLD.collection_filter.updatePagination(a.data.collection, BOLD.collection_filter.collections[a.data.collection].current_page);
  if(BOLD.collection_filter.collections[a.data.collection] && BOLD.collection_filter.collections[a.data.collection].pages_remaining % 10 == 0 || BOLD.collection_filter.collections[a.data.collection].pages_remaining <= 0){
    if(a.data.page == BOLD.collection_filter.collections[a.data.collection].current_page || BOLD.collection_filter.collections[a.data.collection].products_displayed < BOLD.collection_filter.pagination.products_per_page){
      BOLD.collection_filter.clearAndPrintAllProducts(a.data.collection, BOLD.collection_filter.collections[a.data.collection].current_page);
    }
  }

  if(BOLD.collection_filter.collections[a.data.collection].pages_remaining <= 0){
    BOLD.collection_filter.updateFilters(a.data.collection, a.data);
    BOLD.collection_filter.updateCollectionFilters(a.data.collection, a.data.products);
    //TODO: Determine if we need to look for duplicate products


  }

  $('.view-all').on('click', function(e) {
      e.preventDefault();
      var theView = $(this).attr('data-filter');

      $(this).closest('.bold-filter').find('.bold-filter-wrapper').find('input.bold-filter-input.bold-filter-checkbox').each(function() {
        if ( $(this).is(':checked') ) {
            $(this).click();
        }
      });

  });

});
BOLD.common.eventEmitter.on('BOLD_COLLECTION_FILTERS_input_changed', function(a){
  if(!a || !a.data){
    return;
  }
  BOLD.collection_filter.collections[(a.data.collection || BOLD.collection_filter.getCurrentCollectionPage())].current_page = 1;
  BOLD.collection_filter.updateFilters(a.data.collection, a.data);
  

  var boldFilterString = BOLD.collection_filter.setParamFilters(BOLD.collection_filter.collections[(a.data.collection || BOLD.collection_filter.getCurrentCollectionPage())].applied_filters) || '';
	console.log('boldFilterString', boldFilterString);
  if ( boldFilterString != '' ) {

    BOLD.collection_filter.forURLParameter.parameterCollection = a.data.collection || BOLD.collection_filter.getCurrentCollectionPage();
    BOLD.collection_filter.collections[(a.data.collection || BOLD.collection_filter.getCurrentCollectionPage())].current_page = 1;
    var boldParamURLHash = 'collection='+BOLD.collection_filter.forURLParameter.parameterCollection+'&filter='+boldFilterString;
    
    window.history.pushState('', '', '/collections/'+BOLD.collection_filter.forURLParameter.parameterCollection+'?'+ boldParamURLHash);
    BOLD.collection_filter.hideSubCollectionSection();

  // Toggle collection description based on checked filters
    const $description = $('.collection-description');
    $description.hide();
  }
  document.body.scrollTop = document.documentElement.scrollTop = 0;

});
BOLD.common.eventEmitter.on('BOLD_COLLECTION_FILTERS_selections_updated', function(a){  
  if(!a || !a.data){
    return;
  }

  BOLD.collection_filter.clearAndPrintAllProducts(a.data.collection, BOLD.collection_filter.collections[a.data.collection].current_page);
  BOLD.collection_filter.updatePagination(a.data.collection, BOLD.collection_filter.collections[a.data.collection].current_page);
});
BOLD.common.eventEmitter.on('BOLD_COLLECTION_FILTERS_all_collection_filters_applied', function(a){
  if(!a || !a.data){
    return;
  }
  BOLD.collection_filter.updateProductCount(a.data.collection, a.data.products);
});
BOLD.common.eventEmitter.on('BOLD_COLLECTION_FILTERS_filter_count_updated', function(a){
  if(!a || !a.data){
    return;
  }
   BOLD.collection_filter.printProductCount(a.data.collection, a.data.filter_count);

     $('ul.bold-filter-wrapper').each(function() {
         var $this = $(this);
         if ( $this.find('li').not('[data-product-count="0"]').length <= 1 ) {
            $(this).closest('.bold-filter').hide();
         } else {
            $(this).closest('.bold-filter').show();
         }
     });
});
BOLD.common.eventEmitter.on('BOLD_COLLECTION_FILTERS_filter_added', function(a){
  if(!a || !a.data){
    return;
  }
   BOLD.collection_filter.printFilterUpdate(a.data.collection, a.data.category, a.data.value);   
});
BOLD.common.eventEmitter.on('BOLD_COLLECTION_FILTERS_page_changed', function(a){
  if(!a || !a.data){
    return;
  }
  BOLD.collection_filter.updatePagination(a.data.collection, a.data.page);
  if(BOLD.collection_filter.collections[a.data.collection].current_page != a.data.page){
    BOLD.collection_filter.collections[a.data.collection].current_page = a.data.page;
    BOLD.collection_filter.clearAndPrintAllProducts(a.data.collection, a.data.page);
  }
});



BOLD.common.eventEmitter.on('BOLD_COLLECTION_FILTERS_view_changed', function(a){
  if(!a || !a.data){
    return;
  }
  BOLD.collection_filter.clearAndPrintAllProducts(a.data.collection, BOLD.collection_filter.collections[a.data.collection].current_page);
});



BOLD.common.eventEmitter.on('BOLD_COLLECTION_FILTERS_sort_changed', function(a){
      if(!a || !a.data){
        return;
      }

      productSorting(BOLD.collection_filter.collections[a.data.collection].products);
      BOLD.collection_filter.clearAndPrintAllProducts(a.data.collection, BOLD.collection_filter.collections[a.data.collection].current_page);
});


BOLD.common.eventEmitter.on('BOLD_COLLECTION_FILTERS_viewby_changed', function(a){
      if(!a || !a.data){
        return;
      }
      BOLD.collection_filter.updatePagination(a.data.collection, a.data.page);
      BOLD.collection_filter.clearAndPrintAllProducts(a.data.collection, BOLD.collection_filter.collections[a.data.collection].current_page);

});


/* ***************************************************************************************************
		Misc helper functions
 *************************************************************************************************** */
BOLD.helpers = BOLD.helpers || {};
BOLD.helpers.get = BOLD.helpers.get || function(url, success_callback, error_callback){
  var request = new XMLHttpRequest();
  request.open('GET', url, true);
  request.onload = function() {
    if (request.status >= 200 && request.status < 400) {
      // Success!
      var response;
      try {
        response = JSON.parse(request.responseText);
      } catch (e) {
        response = request.responseText;
      } finally {
        if(typeof success_callback === 'function'){
          success_callback(response)
        }
      }
    } else {
      // We reached our target server, but it returned an error
      if(typeof error_callback === 'function'){
        error_callback(request.responseText);
      }
    }
  };
  request.send();
};

BOLD.helpers.triggerCommonEvent = function(bold_event_name, original_event, additional_data){
  if(window.BOLD && BOLD.common && BOLD.common.eventEmitter){
    //Prefix 'BOLD_COMMON' scope if no (BOLD) scope is provided
    bold_event_name = (bold_event_name.indexOf('BOLD_') > -1 ? bold_event_name : 'BOLD_COMMON_' + bold_event_name);
    var eventData = {};
    if(original_event){
      eventData.original_event=original_event;
      if(original_event.target){
        eventData.target=original_event.target;
      }
    }
    if(additional_data){
      eventData.data = additional_data;
    }

    BOLD.common = BOLD.common || {};
    BOLD.common.settings = BOLD.common.settings || {};

    if(window.console && (BOLD.common.settings.log_events || BOLD.common.settings.log_event_data || BOLD.collection_filter.debugMode)){
    }

    BOLD.common.eventEmitter.emit(bold_event_name, eventData);
  }
};

var Shopify = Shopify || {};
BOLD.helpers.formatMoney = /*Shopify.formatMoney ||*/ function(e, t) {
    function n(e, t) {
        return "undefined" == typeof e ? t : e
    }
    function r(e, t, r, i) {
        if (t = n(t, 2),
        r = n(r, ","),
        i = n(i, "."),
        isNaN(e) || null == e)
            return 0;
        e = (e / 100).toFixed(t);
        var o = e.split(".")
          , a = o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + r)
          , s = o[1] ? i + o[1] : "";
        return a + s
    }
    "string" == typeof e && (e = e.replace(".", ""));
    var i = ""
      , o = /\{\{\s*(\w+)\s*\}\}/
      , a = t || BOLD.collection_filter.money_format;
    switch (a.match(o)[1]) {
    case "amount":
        i = r(e, 2);
        break;
    case "amount_no_decimals":
        i = r(e, 0);
        break;
    case "amount_with_comma_separator":
        i = r(e, 2, ".", ",");
        break;
    case "amount_with_space_separator":
        i = r(e, 2, " ", ",");
        break;
    case "amount_with_period_and_space_separator":
        i = r(e, 2, " ", ".");
        break;
    case "amount_no_decimals_with_comma_separator":
        i = r(e, 0, ".", ",");
        break;
    case "amount_no_decimals_with_space_separator":
        i = r(e, 0, " ");
        break;
    case "amount_with_apostrophe_separator":
        i = r(e, 2, "'", ".")
    }
    return a.replace(o, i)
}

/* ***************************************************************************************************
		Polyfill functions for antequated browsers
 *************************************************************************************************** */

// Production steps of ECMA-262, Edition 5, 15.4.4.14
// Reference: http://es5.github.io/#x15.4.4.14
// Credit: https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf?v=example (retrieved 16/Jun/2017)
if (!Array.prototype.indexOf) {
  Array.prototype.indexOf = function(searchElement, fromIndex) {
    var k;
    if (this == null) {
      throw new TypeError('"this" is null or not defined');
    }
    var o = Object(this);
    var len = o.length >>> 0;
    if (len === 0) {
      return -1;
    }
    var n = fromIndex | 0;
    if (n >= len) {
      return -1;
    }
    k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);
    while (k < len) {
      if (k in o && o[k] === searchElement) {
        return k;
      }
      k++;
    }
    return -1;
  };
}


/* ***************************************************************************************************
		Dropdown menu sort
 *************************************************************************************************** */

  function titleSort(a, b){
    var aTitle = a.title;
    var bTitle = b.title;
    return ((aTitle < bTitle) ? -1 : ((aTitle > bTitle) ? 1 : 0));
  }

  function titleDescSort(a, b){
    var aTitle = a.title;
    var bTitle = b.title;
    return ((aTitle > bTitle) ? -1 : ((aTitle < bTitle) ? 1 : 0));
  }

  function priceSortLowToHigh(a, b){
    var aPrice = parseInt(a.price);
    var bPrice = parseInt(b.price);
    return ((aPrice < bPrice) ? -1 : ((aPrice > bPrice) ? 1 : 0));
  }

  function sortStartDate(a, b){
    var aStart = parseInt(a.start);
    var bStart = parseInt(b.start);
    return ((aStart < bStart) ? -1 : ((aStart > bStart) ? 1 : 0));
  }

  function priceSortHighToLow(a, b){
    var aPrice = parseInt(a.price);
    var bPrice = parseInt(b.price);
    return ((aPrice > bPrice) ? -1 : ((aPrice < bPrice) ? 1 : 0));
  }

  function defaultSort(a, b){
    var aDefault = a.order;
    var bDefault = b.order;
    return ((aDefault < bDefault) ? -1 : ((aDefault > bDefault) ? 1 : 0));
  }

  function recentSort(a, b){
    var aSort = a.recent;
    var bSort = b.recent;
    return ((aSort > bSort) ? -1 : ((aSort < bSort) ? 1 : 0));
  }

  function notRecentSort(a, b){
    var aSort = a.recent;
    var bSort = b.recent;
    return ((aSort < bSort) ? -1 : ((aSort > bSort) ? 1 : 0));
  }

  function productSorting(mergedProducts){

    if ($('#SortBy option:selected').val() == "created-ascending"){
      mergedProducts.sort(recentSort);
    }
    else if ($('#SortBy option:selected').val() == "created-descending"){
      mergedProducts.sort(notRecentSort);
    }
    else if ($('#SortBy option:selected').val() == "title-ascending"){
      mergedProducts.sort(titleSort);
    }
    else if ($('#SortBy option:selected').val() == "title-descending"){
      mergedProducts.sort(titleDescSort);
    }
    else if ($('#SortBy option:selected').val() == "price-ascending"){
      mergedProducts.sort(priceSortLowToHigh);
    }
    else if ($('#SortBy option:selected').val() == "price-descending"){
      mergedProducts.sort(priceSortHighToLow);
    }
    else if ($('#SortBy option:selected').val() == "best-selling"){
      mergedProducts.sort(defaultSort);
    }

  }
